<template>
  <div class="consultation-info">
    <div class="consultation-info__styles" aria-label="선호 스타일">
      <template v-if="info.preferences.length">
        <el-tag
          v-for="style in info.preferences"
          :key="style"
          class="consultation-info__tag"
        >
          {{ styleLabel(style) }}
        </el-tag>
      </template>
      <span v-else class="consultation-info__empty">미선택</span>
    </div>
    <div class="consultation-info__detail">
      <span class="consultation-info__label">예산</span>
      <span :class="{ 'consultation-info__empty': !info.budget }">{{
        info.budget || "미입력"
      }}</span>
    </div>
    <div class="consultation-info__detail">
      <span class="consultation-info__label">결혼식 예정일</span>
      <span :class="{ 'consultation-info__empty': !info.weddingDate }">{{
        info.weddingDate || "미입력"
      }}</span>
    </div>
    <div v-if="info.requestMemo" class="consultation-info__request">
      <span class="consultation-info__label">고객 요청사항</span>
      <p
        :id="`consultation-request-${schedule._id}`"
        class="consultation-info__request-text"
        v-text="requestExpanded ? info.requestMemo : requestPreview"
      ></p>
      <el-button
        v-if="requestPreview !== info.requestMemo"
        type="text"
        size="mini"
        :aria-expanded="String(requestExpanded)"
        :aria-controls="`consultation-request-${schedule._id}`"
        :aria-label="
          requestExpanded ? '고객 요청사항 접기' : '고객 요청사항 전체 보기'
        "
        @click="requestExpanded = !requestExpanded"
        >{{ requestExpanded ? "접기" : "전체 보기" }}</el-button
      >
    </div>
  </div>
</template>

<script>
import consultation from "@shared/reservationConsultation.cjs";

export default {
  props: { schedule: { type: Object, required: true } },
  data() {
    return { requestExpanded: false };
  },
  computed: {
    info() {
      return consultation.getConsultationInfo(this.schedule);
    },
    requestPreview() {
      const memo = this.info.requestMemo;
      const preview = memo.split("\n").slice(0, 3).join("\n").slice(0, 80);
      return preview.length < memo.length ? `${preview}…` : memo;
    },
  },
  watch: {
    "schedule._id"() {
      this.requestExpanded = false;
    },
  },
  methods: {
    styleLabel(style) {
      return (
        { 미니멀함: "심플", 유니크함: "유니크", 모던함: "모던" }[style] || style
      );
    },
  },
};
</script>

<style src="./ReservationConsultationInfo.styles.css" scoped></style>
